import { render, staticRenderFns } from "./UnitNote.vue?vue&type=template&id=f66b7aa4&scoped=true&"
import script from "./UnitNote.vue?vue&type=script&lang=js&"
export * from "./UnitNote.vue?vue&type=script&lang=js&"
import style0 from "./UnitNote.vue?vue&type=style&index=0&id=f66b7aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66b7aa4",
  null
  
)

export default component.exports